/*!
   Copyright 2019 Ron Buckton

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/

/* @internal */ export function isInt(value: number): boolean {
    return isFinite(value) && (value % 1) === 0;
}

/* @internal */ export function compareNumbers(a: number, b: number) {
    return Math.sign(a - b);
}

/* @internal */ export function compareBigInts(a: bigint, b: bigint) {
    return a < b ? -1 : a > b ? 1 : 0;
}

/* @internal */ export function compareStrings(a: string, b: string) {
    return a < b ? -1 : a > b ? +1 : 0;
}

const normalizeRegExp = /[−,]/g;
const normalizeReplacer = (s: string) => s === "−" ? "-" : ".";

/* @internal */ export function normalizeString(text: string) {
    return text.replace(normalizeRegExp, normalizeReplacer);
}

/* @internal */ export const CIVILDATE_HASH_SEED = 139;
/* @internal */ export const CIVILTIME_HASH_SEED = 140;
/* @internal */ export const CIVILDATETIME_HASH_SEED = 141;
/* @internal */ export const DURATION_HASH_SEED = 143;
/* @internal */ export const INSTANT_HASH_SEED = 144;
/* @internal */ export const INTERVAL_HASH_SEED = 145;
/* @internal */ export const OFFSETDATETIME_HASH_SEED = 146;
/* @internal */ export const OFFSETTIME_HASH_SEED = 147;
/* @internal */ export const RECURRINGINTERVAL_HASH_SEED = 148;
/* @internal */ export const ZONE_HASH_SEED = 149;
/* @internal */ export const ZONEOFFSET_HASH_SEED = 150;
/* @internal */ export const ZONEDDATETIME_HASH_SEED = 151;